// extracted by mini-css-extract-plugin
module.exports = {"addUser":"AddUserGroup_addUser__3fir3","buttonsWrapper":"AddUserGroup_buttonsWrapper__2BbKJ"};